import React from 'react'
import { Spinner } from 'react-bootstrap'
import { IoIosRepeat } from 'react-icons/io'
import { Tooltip } from 'react-tooltip'

interface RefreshComponentProps {
    onClick: () => void; // Define the type for onClick
    isLoading?: boolean;
}

const RefreshComponent: React.FC<RefreshComponentProps> = ({ onClick, isLoading = false }) => {
    return (
        <>
            <Tooltip id="refreshData" place="top" />
            <div
                data-tooltip-id="refreshData"
                data-tooltip-content={isLoading ? 'Refreshing...' : 'Refresh Data'}
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-2 p-2'
                onClick={isLoading ? undefined : onClick}
                style={{ cursor: isLoading ? 'not-allowed' : 'pointer' }}
                aria-busy={isLoading}
            >
                {isLoading ? (
                    <Spinner animation="border" size="sm" role="status" aria-hidden="true" />
                ) : (
                    <IoIosRepeat className='h-20px w-20px' />
                )}
            </div>
        </>
    )
}

export default RefreshComponent
